import './index.css';
import router from './router';
import { createApp } from 'vue';
import { createPinia } from 'pinia';

import PrimeVue from 'primevue/config';
import Nora from '@primevue/themes/nora';
import ToastService from 'primevue/toastservice';

import {
  Button,
  Fieldset,
  DatePicker,
  ToggleSwitch,
  Select,
  MultiSelect,
  InputText,
  Panel,
  Card,
  Toast,
  Chip,
} from 'primevue';


import AdminPanel from './App.vue';

const adminApp = createApp(AdminPanel);

adminApp.use(PrimeVue, {
  locale: {},
  theme: {
    preset: Nora,
    options: {
      prefix: 'pv',
      darkModeSelector: '.dark',
      cssLayer: true,
    },
  },
});

adminApp.component('Button', Button);
adminApp.component('Fieldset', Fieldset);
adminApp.component('DatePicker', DatePicker);
adminApp.component('ToggleSwitch', ToggleSwitch);
adminApp.component('Select', Select);
adminApp.component('MultiSelect', MultiSelect);
adminApp.component('InputText', InputText);
adminApp.component('Panel', Panel);
adminApp.component('Card', Card);
adminApp.component('Toast', Toast);
adminApp.component('Chip', Chip);

adminApp.use(createPinia());
adminApp.use(ToastService);

adminApp.use(router);

adminApp.mount('#app');
